import React from 'react';
import {
  
  TextInput,
  Textarea,
  Button,
  Stack,
  Group,
  Grid,
  
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconPhone, IconMail, IconUser, IconMapPin } from '@tabler/icons-react';
import { InquiryFormValues } from '../../types';

interface InquiryFormProps {
  productName?: string;
  onSubmit: (values: InquiryFormValues) => void;
  submitting?: boolean;
}

export const InquiryForm: React.FC<InquiryFormProps> = ({ 
  productName, 
  onSubmit, 
  submitting = false 
}) => {
  const form = useForm<InquiryFormValues>({
    initialValues: {
      name: '',
      email: '',
      phone: '',
      country: '',
      product: productName || '',
      quantity: '',
      message: '',
    },
    validate: {
      name: (value) => (value.length < 2 ? 'Name is too short' : null),
      email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
      phone: (value) => (value.length < 10 ? 'Invalid phone number' : null),
      country: (value) => (value.length < 2 ? 'Please enter your country' : null),
      product: (value) => (value.length < 2 ? 'Please enter product name' : null),
      message: (value) => (value.length < 10 ? 'Message is too short' : null),
    },
  });

  const handleSubmit = (values: InquiryFormValues) => {
    onSubmit(values);
    if (!submitting) {
      form.reset();
    }
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack gap="md">
        <Grid>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label="Full Name"
              placeholder="Enter your full name"
              leftSection={<IconUser size={16} />}
              {...form.getInputProps('name')}
              required
              disabled={submitting}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label="Email"
              placeholder="your@email.com"
              leftSection={<IconMail size={16} />}
              {...form.getInputProps('email')}
              required
              disabled={submitting}
            />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label="Phone"
              placeholder="+1 234 567 8900"
              leftSection={<IconPhone size={16} />}
              {...form.getInputProps('phone')}
              required
              disabled={submitting}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label="Country"
              placeholder="Your country"
              leftSection={<IconMapPin size={16} />}
              {...form.getInputProps('country')}
              required
              disabled={submitting}
            />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label="Product Interested"
              placeholder="e.g., Basmati Rice, Wheat, Mangoes"
              {...form.getInputProps('product')}
              required
              disabled={productName ? true : submitting}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <TextInput
              label="Quantity Required"
              placeholder="e.g., 10 Metric Tons"
              {...form.getInputProps('quantity')}
              disabled={submitting}
            />
          </Grid.Col>
        </Grid>

        <Textarea
          label="Message"
          placeholder="Tell us about your requirements..."
          minRows={4}
          {...form.getInputProps('message')}
          required
          disabled={submitting}
        />

        <Group justify="flex-end" mt="md">
          <Button 
            type="submit" 
            color="exportGreen" 
            size="lg"
            loading={submitting}
            loaderProps={{ type: 'dots' }}
          >
            {submitting ? 'Sending...' : 'Submit Inquiry'}
          </Button>
        </Group>
      </Stack>
    </form>
  );
};